
<template>
  <p class="com-origin-source" v-html="dataInfo.value"></p>
</template>

<script>
import { CptMixin } from '../../../mixins/CptMixin'
export default {
  mixins: [CptMixin],
}
</script>

<style lang="less">
.com-origin-source {
  margin-top: 20px;
  line-height: 25px;
  font-size: 14px;
  color: #8c96a0;
  text-align: right;
  br {
    display: block;
  }
}
</style>